/** @format */

import { useRef, useEffect, useState } from "react";
import { Search } from "../../global/search";
import ClickAwayListener from "@mui/material/ClickAwayListener";
const FilterPop = ({
  options,
  showModal,
  stateName,
  getSearchValue,
  searchValues,
  label,
  hideModal,
}) => {
  const [active, setActve] = useState("");

  const handleClick = ({ target }) => {
    hideModal();
    getSearchValue(target.textContent, label, stateName);
    setActve(target.textContent);
  };

  return (
    <ul className={`filter-pop ${!showModal && "filter-pop--hidden"}`}>
      {!options?.length && (
        <Search
          value={searchValues}
          getSearchValue={getSearchValue}
          icon={false}
          placeholder='اكتب الحالة الذي تريد البحث عنه'
          stateName={stateName}
          showBtn
          label={label}
          hideModal={hideModal}
        />
      )}
      {options?.map((item, key) => (
        <li
          className={`filter-pop__item ${
            item.label === active ? "filter-pop__item--active" : ""
          }`}
          key={key}
          onClick={handleClick}>
          {item.label}
        </li>
      ))}
    </ul>
  );
};

export default FilterPop;
